import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import HTMLReactParser from 'html-react-parser';
import { useGlobal } from "../../utils/GlobalContext";

function AboutConferenceArea() {

    const { state } = useGlobal();

    return (
        <div>
            <Grid container spacing={.5}>
                <Grid item xs={12} md={6}>  
                    {HTMLReactParser(state.Conference?.MissionStatement ?? '')}
                    <br/>
                    {HTMLReactParser(state.Conference?.LocationHeader )}
                    <div className="aboutBold">{state.SelectedEvent.Address1}</div>
                    <div className="aboutBold">{state.SelectedEvent.Address2}</div>
                    <span className="aboutBold">
                        {state.SelectedEvent.City}, {state.SelectedEvent.State} {state.SelectedEvent.Zip}
                    </span>
                </Grid>
                <Grid item xs={12} md={6}>        
                    {HTMLReactParser(state.Conference?.MiscInfo ?? '')}
                </Grid>
            </Grid>
        </div>
    );
}

export default AboutConferenceArea;